<template>
    <div class="max-w-3xl mx-auto px-2 md:px-0">
        <div class="flex flex-col items-center">
            <span class="inline-block relative cursor-pointer">
                <img
                    id="pick-avatar"
                    :src="userAvatar"
                    class="inline-block rounded-md h-56 w-aut"
                    title="변경"
                />
            </span>
            <avatar-cropper
                trigger="#pick-avatar"
                :upload-handler="cropped"
                :labels="{ submit: '확인', cancel: '취소' }"
                :cropper-options="{ aspectRatio: 1.34 }"
            />
        </div>
        <div class="mt-8 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-2">
            <div>
                <label
                    for="name"
                    class="text-sm font-medium leading-5 text-gray-700"
                    >이름</label
                >
                <input
                    id="name"
                    type="text"
                    v-model.trim="$v.form.name.$model"
                    class="my-1 form-input w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    :class="{ 'border-red-500': $v.form.name.$error }"
                />
                <div
                    v-if="$v.form.name.$error || errors.name"
                    class="text-red-500 text-xs italic"
                >
                    필수입력 항목입니다.
                </div>
            </div>
            <div>
                <label
                    for="name_en"
                    class="text-sm font-medium leading-5 text-gray-700"
                    >영문 이름</label
                >
                <input
                    id="name_en"
                    type="text"
                    v-model.trim="form.name_en"
                    class="my-1 form-input w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
            </div>
            <div>
                <label
                    for="email"
                    class="text-sm font-medium leading-5 text-gray-700"
                    >이메일주소</label
                >
                <div>
                    <input
                        id="email"
                        type="text"
                        v-model.trim="$v.form.email.$model"
                        class="my-1 form-input w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        :class="{ 'border-red-500': $v.form.email.$error }"
                    />
                    <div
                        v-if="errors.email"
                        class="text-red-500 text-xs italic"
                    >
                        {{ errors.email[0] }}
                    </div>
                    <template v-if="$v.form.email.$error">
                        <div
                            v-if="!$v.form.email.required"
                            class="text-red-500 text-xs italic"
                        >
                            필수입력 항목입니다.
                        </div>
                        <div
                            v-if="!$v.form.email.email"
                            class="text-red-500 text-xs italic"
                        >
                            이메일 형식이 아닙니다.
                        </div>
                    </template>
                </div>
            </div>
            <div>
                <label
                    for="website"
                    class="text-sm font-medium leading-5 text-gray-700"
                    >웹사이트/SNS (http:// 또는 https:// 로 시작)</label
                >
                <input
                    id="website"
                    type="url"
                    v-model="form.website"
                    placeholder="https://www.instagram.com/nike"
                    class="my-1 form-input w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
            </div>
            <div>
                <label
                    for="dob"
                    class="text-sm font-medium leading-5 text-gray-700"
                    >생년월일</label
                >
                <input
                    id="dob"
                    type="date"
                    v-model="form.dob"
                    class="my-1 form-input w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
            </div>
            <div class="flex items-center text-sm">
                <input
                    id="lunar"
                    v-model="form.lunar"
                    type="checkbox"
                    class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                />
                <label for="lunar" class="ml-1 font-medium text-gray-700"
                    >음력</label
                >
            </div>
            <div>
                <label
                    for="region"
                    class="text-sm font-medium leading-5 text-gray-700"
                    >활동 지역</label
                >
                <input
                    id="region"
                    type="text"
                    v-model.trim="form.region"
                    class="my-1 form-input w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
            </div>
            <div>
                <label
                    for="teacher"
                    class="text-sm font-medium leading-5 text-gray-700"
                    >지도 스승</label
                >
                <input
                    id="teacher"
                    type="text"
                    v-model.trim="form.teacher"
                    class="my-1 form-input w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
            </div>
            <div class="col-span-1 sm:col-span-2">
                <label
                    for="memo"
                    class="text-sm font-medium leading-5 text-gray-700"
                    >자기소개 및 이력</label
                >
                <textarea
                    id="memo"
                    v-model.trim="form.memo"
                    rows="8"
                    class="my-1 form-textarea w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                ></textarea>
            </div>
            <div>
                <label
                    for="grade"
                    class="text-sm font-medium leading-5 text-gray-700"
                >
                    지도자 등급
                </label>
                <div class="my-1 rounded-md shadow-sm">
                    <select
                        id="grade"
                        v-model="form.grade"
                        class="form-select w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    >
                        <slot />
                    </select>
                </div>
            </div>
        </div>
        <div class="flex items-center justify-between mt-6">
            <div>
                <span class="inline-flex rounded-md shadow-sm">
                    <button
                        type="button"
                        @click="onSubmit"
                        class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out disabled:opacity-50 disabled:cursor-not-allowe"
                        :disabled="$v.$invalid || saving"
                    >
                        {{ saving ? '처리 중...' : '저장' }}
                    </button>
                </span>
                <button
                    type="button"
                    @click="goBack()"
                    class="py-2 px-4 text-sm hover:text-gray-600"
                >
                    취소
                </button>
            </div>
            <span class="inline-flex rounded-md shadow-sm">
                <button
                    type="button"
                    @click="onDelete"
                    class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red active:bg-indigo-700 transition duration-150 ease-in-out disabled:opacity-50 disabled:cursor-not-allowe"
                    :disabled="$v.$invalid || saving"
                >
                    {{ saving ? '처리 중...' : '삭제' }}
                </button>
            </span>
        </div>
    </div>
</template>

<script>
import AvatarCropper from 'vue-avatar-cropper'
import { validationMixin } from 'vuelidate'
import { required, email, numeric } from 'vuelidate/lib/validators'

export default {
    components: { AvatarCropper },

    mixins: [validationMixin],

    props: {
        master: Object,
    },

    data() {
        return {
            mode: 'new',
            saving: false,
            errors: [],
            userAvatar: '/img/null-logo.png',
            form: {
                name: null,
                name_en: null,
                email: null,
                phone: null,
                dob: null,
                lunar: false,
                region: null,
                teacher: null,
                grade: 11,
                memo: null,
                avatar: null,
            },
        }
    },

    validations: {
        form: {
            name: {
                required,
            },
            email: {
                required,
                email,
            },
        },
    },

    created() {
        if (this.master) {
            this.mode = 'edit'
            this.form = this.master
            this.form.dob = this.master.birthday || null
            this.userAvatar = this.master.thumbnail
        }
    },

    computed: {
        endpoint() {
            return this.mode === 'new'
                ? '/masters'
                : `/masters/${this.master.id}`
        },
    },

    methods: {
        goBack() {
            location.href = '/masters'
        },

        cropped(cropper) {
            const src = cropper
                .getCroppedCanvas({
                    minWidth: 640,
                    maxHeight: 640,
                })
                .toDataURL('image/jpeg', 1.0)
            this.userAvatar = this.form.avatar = src
        },

        async onSubmit() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                return false
            }

            this.saving = true

            try {
                const method = this.mode === 'new' ? 'post' : 'patch'
                const response = await axios[method](this.endpoint, this.form)

                this.saving = false
                location.href = '/masters'
            } catch (error) {
                this.handleError(error)
            }
        },

        async onDelete() {
            const result = await this.$swal({
                text: '정말 삭제할까요?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#e02424',
                confirmButtonText: '삭제합니다',
                cancelButtonText: '취소',
            })

            if (!result.value) {
                return
            }

            this.saving = true

            try {
                const response = await axios.delete(
                    `/masters/${this.master.id}`
                )

                this.saving = false
                location.href = '/masters'
            } catch (error) {
                handleError(error)
            }
        },

        handleError(error) {
            this.saving = false

            if (error.response.status !== 422) {
                console.log('알 수 없는 오류가 발생했습니다.')
            } else {
                const message =
                    error.response.data.message || error.response.data
                this.$swal.error(message)
            }

            this.errors = error.response.data.errors || []
        },
    },
}
</script>
